const DIMS = {
    tshirt: {
        map: {
            map_area_width: 650,
            height: 660,
            color: "#ffffff"
        },
    },
    sixoz_white: {
        map: {
            map_area_width: 650,
            height: 660,
            color: "#454447"
        },
    },
    sixoz: {
        map: {
            map_area_width: 650,
            height: 660,
            color: "#454447"
        }
    },
};
//var lat = 38.889300715775995, lng = -77.02918930816266;
var lng = -86.78, lat = 36.16; // Harlingen
var bottle = "tshirt", scale = 228199 * 2 * Math.PI, map_style = "standard";
var projection, path, tile, map, layer, tileProjection, tilePath, zoom;
var zoomExtent = [1 << 10, 1 << 24];
var prefix = prefixMatch(["webkit", "ms", "Moz", "O"]);
var pJSON = {
    city: "Custom",
    state: "Anywhere",
    coordinates: formatCoordinates(lng, lat, 2)
}
var pi = Math.PI, tau = 2 * pi;
var map_width = 650, map_height = 660;
var source_image = new Image;
var COLOR, INSCRIPTION, apparel_style;

window.addEventListener('load', initializeCustomMaps);

function initializeCustomMaps() {
    startGoogleAutocomplete();
    setGlobals();
    registerQueryVars();
    registerMap();
    resizeContainers();
    registerForm();
    setHiddenFields();
    updateImages();

    $('#map').on('touchstart, touchmove', function (e) {
        if (e.target.nodeName == "svg") {
            e.preventDefault();
            return false;
        }
    });
}

function startGoogleAutocomplete() {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.onload = function () {
    };
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAge_eWvhcZCv8KOhmm_R3nxMe_qW7BQRA&libraries=places&callback=initAutocomplete';
    document.getElementsByTagName('head')[0].appendChild(script);

    // Needed to prevent enter key on Google autocomplete from triggering cart add
    $(window).keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });
}

function registerQueryVars() {
    if (getQueryVariable("lng") && Math.abs(Number(getQueryVariable("lng"))) <= 181) lng = Number(getQueryVariable("lng"));
    if (getQueryVariable("lat") && Math.abs(Number(getQueryVariable("lat"))) <= 181) lat = Number(getQueryVariable("lat"));
    if (Number(getQueryVariable("scale"))) scale = Number(getQueryVariable("scale"));
    if (getQueryVariable("custom-text")) {
        var myText1 = getQueryVariable("custom-text");
        myText1 = myText1.replace(/!nbsp!/g, ' ').replace(/%21nbsp%21/g, ' ');
        $("#custom_inscription_text").val(decodeURIComponent(myText1));
    }
    if (getQueryVariable("size")) {
        var size = getQueryVariable("size").toUpperCase();
        if (size == "XS" || size == "S" || size == "M" || size == "L" || size == "XL" || size == "2XL") {
            $(".options-selection__option-value-input[value='" + size + "']").click();
            $("#jace-tshirt-size-label").text(size);
            $("#jace-tshirt-size").attr("data-value", size).val(size);
            var print_url = "&size=" + size;
            $("#print-url").attr("data-value", print_url).attr("value", print_url);
        }
    }
}

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
    }
    return (false);
}

function generateSVGMap() {

    renderSVG(function (tiles) {
        console.log("Completed with " + tiles + " tiles");
        console.log(document.getElementById('map-inscription-text').innerHTML);
        var svg_xml = new XMLSerializer().serializeToString(document.getElementById("new-svg"));
        source_image = new Image;
        source_image.onload = function () {
            console.log("rendered");
            updateFlat();
            updateLifestyle1();
            updateLifestyle2();
            updateDetailsCanvas();
        };
        source_image.src = "data:image/svg+xml;base64," + btoa(svg_xml);
    });

    function renderSVG(callback) {
        $(".g_layer").remove();
        var map_w = map_width;
        var map_h = map_height;
        var map_lng = projection.invert([
            map_width / 2,
            map_height / 2,
        ])[0];
        var map_lat = projection.invert([
            map_width / 2,
            map_height / 2,
        ])[1];
        var map_scale = zoom.scale() / 2 / Math.PI;
        var map_new_projection = d3.geo
            .mercator()
            .translate([map_w / 2, map_h / 2])
            .scale(map_scale)
            .center([map_lng, map_lat])
            .clipExtent([
                [0, 0],
                [map_w, map_h],
            ]);
        var map_path = d3.geo.path().projection(map_new_projection);
        var map_tiler = d3.geo.tile().size([map_w, map_h]);
        var new_svg = d3.select("#new-svg");
        new_svg.attr("width", map_width + "px");
        new_svg.attr("height", (map_height + 20) + "px");
        new_svg.attr("viewBox", "0 0 " + map_width + " " + (map_height + 20));
        d3.select("#svg_style").remove();
        new_svg
            .append("style")
            .attr("id", "svg_style")
            .text(
                "g path {stroke:#fff;stroke-linejoin: round;stroke-linecap: round;stroke-width: 1px;} text {fill: #fff;font-family:Helvetica-Light;font-size:18px;}"
            );
        new_svg.append("g").attr("class", "g_layer").append("text").attr("x", "100%").attr("y", "679").attr("text-anchor", "end").text(document.getElementById('map-inscription-text').innerHTML);

        if (map_style == "topographic") {
            renderSVGTopoTiles(
                new_svg,
                map_tiler,
                map_new_projection,
                map_path,
                function (num_tiles, completed_tiles) {
                    //console.log(completed_tiles + "/" + num_tiles);
                    if (num_tiles == completed_tiles) {
                        callback(completed_tiles);
                    }
                }
            );
        } else {
            renderSVGStandardTiles(
                new_svg,
                map_tiler,
                map_new_projection,
                map_path,
                function (num_tiles, completed_tiles) {
                    //console.log(completed_tiles + "/" + num_tiles);
                    if (num_tiles == completed_tiles) {
                        callback(completed_tiles);
                    }
                }
            );
        }


    }

    function renderSVGStandardTiles(
        svg,
        new_tiler,
        new_projection,
        new_path,
        callback
    ) {
        var num_tiles = 0;
        var got_tiles = 0;
        svg
            .append("g")
            .attr("class", "g_layer")
            .selectAll("g")
            .data(
                new_tiler
                    .scale(new_projection.scale() * 2 * Math.PI)
                    .translate(new_projection([0, 0]))
            )
            .enter()
            .append("g")
            .each(function (d) {
                num_tiles += 1;
                var g = d3.select(this);

                if (d[2] >= 13) {
                    var layers = ["road", "aeroway"];
                    var key =
                        "pk.eyJ1IjoiZWx3aW5vbmciLCJhIjoiY2lzNWhicDJuMGI2cDJubzBuc2VzZXFudiJ9.PzLYfKC87uptmIAYDeBknw";
                    var mapbox_id = "mapbox.mapbox-streets-v7";
                    var url =
                        "https://" +
                        ["a", "b", "c", "d"][(Math.random() * 3) | 0] +
                        ".tiles.mapbox.com/v4/" +
                        mapbox_id +
                        "/" +
                        d[2] +
                        "/" +
                        d[0] +
                        "/" +
                        d[1] +
                        ".mvt?access_token=" +
                        key;

                    // url =
                    //     "https://d2rfypejqz1iux.cloudfront.net/tilezen/vector/v1/all/" +
                    //     d[2] +
                    //     "/" +
                    //     d[0] +
                    //     "/" +
                    //     d[1] +
                    //     ".mvt?api_key=gU55ZUmrR4iYlPtqon4g_Q";
                    // layers = ["roads", "aeroway", "water"];

                    url = "https://3kje40nc62.execute-api.us-east-1.amazonaws.com/prod/tilezen/vector/v1/256/all/" + d[2] + "/" + d[0] + "/" + d[1] + ".mvt";
                    layers = ["roads", "aeroway", "water"];
                } else {
                    var layers = ["water", "roads"];
                    var url =
                        "https://d1w2ve2kvbvjmf.cloudfront.net/v1/" +
                        d[2] +
                        "/" +
                        d[0] +
                        "/" +
                        d[1] +
                        ".mvt";
                }

                this._xhr = d3
                    .xhr(url)
                    .responseType("arraybuffer")
                    .get(function (error, json) {
                        if (!error && json.status == 200) {
                            try {
                                // var tile_res = new VectorTile(
                                //     new Pbf(new Uint8Array(json.response))
                                // );
                                var tile_res = new NewVectorTile(new Pbf(new Uint8Array(json.response)));
                                //var tile_res = new VectorTile( new Pbf( new Uint8Array(json.response) ) );
                            } catch (e) {
                                console.log(e);
                                got_tiles += 1;
                                callback(num_tiles, got_tiles);
                                return;
                            }

                            var features = [];
                            layers.forEach(function (layer) {
                                try {
                                    for (
                                        var i = 0, len = tile_res.layers[layer].length;
                                        i < len;
                                        i++
                                    ) {
                                        var f = tile_res.layers[layer]
                                            .feature(i)
                                            .toGeoJSON(d[0], d[1], d[2]);
                                        f.layer = layer;
                                        if (
                                            f.geometry.type == "Point" ||
                                            f.geometry.type == "MultiPoint"
                                        )
                                            continue;
                                        if (layer == "road" || layer == "roads") {
                                            if (f.properties.kind == "ferry") continue;
                                            if (f.properties.kind == "rail") continue;
                                            if (f.properties.class == "ferry") continue;
                                            if (f.properties.class == "major_rail") continue;
                                            if (f.properties.class == "minor_rail") continue;
                                            if (f.properties.class == "pedestrian") continue;
                                        }
                                        if (layer == "water" && !f.properties.boundary) continue;
                                        if (layer == "water" && f.properties.kind == "river")
                                            continue;
                                        features.push(f);
                                    }
                                } catch (err) {
                                    //console.log(err);
                                }
                            });
                            //console.log(features);

                            g.selectAll("path")
                                .data(features)
                                .enter()
                                .append("path")
                                .attr("class", function (d) {
                                    return d.layer + "-layer " + d.properties.class;
                                })
                                .attr("d", new_path)
                                .attr("fill", "none");
                        }

                        if (d[2] >= 13) {
                            //renderSVGWaterTiles(g, d, new_path, new_projection, function() {
                            got_tiles += 1;
                            callback(num_tiles, got_tiles);
                            //});
                        } else {
                            got_tiles += 1;
                            callback(num_tiles, got_tiles);
                        }
                    });
            });
        var pathSimplified = function (d) {
            if (typeof new_path(d) !== "undefined")
                return new_path(d).replace(/(\.\d{2})\d+/g, "$1");
            else return "";
        };
    }

    function renderSVGTopoTiles(
        svg,
        new_tiler,
        new_projection,
        new_path,
        callback
    ) {
        var num_tiles = 0;
        var got_tiles = 0;
        svg
            .append("g")
            .attr("class", "g_layer")
            .selectAll("g")
            .data(
                new_tiler
                    .scale(new_projection.scale() * 2 * Math.PI)
                    .translate(new_projection([0, 0]))
            )
            .enter()
            .append("g")
            .each(function (d) {
                num_tiles += 1;
                var g = d3.select(this);

                this._xhr = d3
                    .xhr(
                        "https://api.maptiler.com/tiles/contours/" +
                        d[2] +
                        "/" +
                        d[0] +
                        "/" +
                        d[1] +
                        ".pbf?key=THIUxOiVkaLgsNtCXqMe"
                    )
                    .responseType("arraybuffer")
                    .get(function (error, json) {
                        if (!error && json.status == 200) {
                            try {
                                // var tile_res = new VectorTile(
                                //     new Pbf(new Uint8Array(json.response))
                                // );
                                var tile_res = new NewVectorTile(new Pbf(new Uint8Array(json.response)));

                                var features = [];
                                for (
                                    var i = 0, len = tile_res.layers["contour"].length;
                                    i < len;
                                    i++
                                ) {
                                    features.push(
                                        tile_res.layers["contour"]
                                            .feature(i)
                                            .toGeoJSON(d[0], d[1], d[2])
                                    );
                                }

                                g.selectAll("path")
                                    .data(features)
                                    .enter()
                                    .append("path")
                                    .attr("class", "contour-layer")
                                    .attr("d", new_path)
                                    .attr("fill", "none");

                            } catch (e) {
                                console.log(e);
                                got_tiles += 1;
                                callback(num_tiles, got_tiles);
                            }
                        }

                        renderSVGWaterTiles(g, d, new_path, new_projection, function () {
                            got_tiles += 1;
                            callback(num_tiles, got_tiles);
                        });
                    });
            });
    }

    function renderSVGWaterTiles(g, d, new_path, new_projection, callback) {

        var k = Math.pow(2, d[2]) * 256; // size of the world in pixels

        if (d[2] >= 13) {
            var url = "https://3kje40nc62.execute-api.us-east-1.amazonaws.com/prod/tilezen/vector/v1/256/all/" + d[2] + "/" + d[0] + "/" + d[1] + ".mvt";
            var layers = ["water"];

        } else {
            var layers = ['water'];
            var url = "https://d1w2ve2kvbvjmf.cloudfront.net/v1/" + d[2] + "/" + d[0] + "/" + d[1] + ".mvt";
        }

        d3.xhr(url)
            .responseType("arraybuffer")
            .get(function (error, json) {
                if (error || json.status !== 200) {
                    callback();
                } else {
                    try {
                        // var w_buf = new Uint8Array(json.response);
                        // var w_pbf = new Pbf(pako.inflate(w_buf));
                        // var w_tile_res = new VectorTile(w_pbf);
                        var w_tile_res = new NewVectorTile(new Pbf(new Uint8Array(json.response)));
                    } catch (e) {
                        console.log(e);
                        return;
                    }

                    var w_features = [];
                    var w_layers = ["water"];
                    w_layers.forEach(function (w_layer) {
                        try {
                            for (
                                var i = 0, len = w_tile_res.layers[w_layer].length;
                                i < len;
                                i++
                            ) {
                                var f = w_tile_res.layers["water"].feature(i).toGeoJSON(d[0], d[1], d[2]);
                                if (f.geometry.type == "Point" || f.geometry.type == "MultiPoint") continue;
                                if (!f.properties.boundary) continue;
                                if (f.properties.kind == "river") continue;
                                w_features.push(f);
                            }
                        } catch (err) {
                            //console.log(err);
                        }
                    });

                    g.selectAll("path.water-layer")
                        .data(w_features)
                        .enter()
                        .append("path")
                        .attr("class", "water-layer")
                        .attr("d", new_path)
                        .attr("fill", "none");

                    callback();
                }
            });
    }
}

function registerMap() {
    var B = DIMS[bottle].map;

    $(".product-gallery--image-background:eq(1)").first().append($("#map-frame"));

    tile = d3.geo.tile().size([B.map_area_width, B.height]);
    projection = d3.geo.mercator().scale(scale / 2 / Math.PI).translate([- B.map_area_width / 2, - B.height / 2]);
    zoom = d3.behavior.zoom().scale(projection.scale() * 2 * Math.PI).scaleExtent(zoomExtent).translate(projection([lng, lat]).map(function (x) { return -x; })).on("zoom", function () { zoomed(); });

    map = d3.select("#map").call(zoom);
    layer = map.append("div").attr("class", "layer");
    tileProjection = d3.geo.mercator();
    tilePath = d3.geo.path().projection(tileProjection);
    zoomed();
}

var waitZoomed = false;
function zoomed() {

    var tiles = tile.scale(zoom.scale()).translate(zoom.translate())();

    projection.scale(zoom.scale() / 2 / Math.PI).translate(zoom.translate());

    var image = layer.style("transform", matrix3d(tiles.scale, tiles.translate)).selectAll(".tile").data(tiles, function (d) {
        return d;
    });
    image.exit().each(function (d) {
        this._xhr.abort();
    }).remove();

    if (map_style == "topographic") {
        image.enter().append("svg").attr("class", "tile").style("left", function (d) {
            return d[0] * 256 + "px";
        }).style("top", function (d) {
            return d[1] * 256 + "px";
        }).each(renderTopoTiles);
    } else {
        image.enter().append("svg").attr("class", "tile").style("left", function (d) {
            return d[0] * 256 + "px";
        }).style("top", function (d) {
            return d[1] * 256 + "px";
        }).each(renderStandardTiles);
    }


    for (var i = 0; i < $("#map .layer").length - 1; i++) {
        $("#map .layer")[i].remove();
    };

    setHiddenFields();
    waitZoomed = true;
    // var newZoom = Date.now();
    // if ((newZoom - waitZoomed) > 3000) {
    //     waitZoomed = newZoom;
    //     setTimeout(function () {
    //         console.log("Zoomed");
    //         drawMapText();
    //         updateImages();
    //     }, 2500);
    // }

}

function renderStandardTiles(d) {
    var svg = d3.select(this);

    if (d[2] >= 13) {
        //        var layers = ["road", "aeroway"];
        //        var key = "pk.eyJ1IjoiZWx3aW5vbmciLCJhIjoiY2lzNWhicDJuMGI2cDJubzBuc2VzZXFudiJ9.PzLYfKC87uptmIAYDeBknw";
        //	    var mapbox_id = "mapbox.mapbox-streets-v8";
        //        var url = "https://"+["a", "b", "c", "d"][Math.random() * 3 | 0]+".tiles.mapbox.com/v4/" + mapbox_id + "/" + d[2] + "/" + d[0] + "/" + d[1] + ".mvt?access_token=" + key;
        //    
        //        url = "https://tile.nextzen.org/tilezen/vector/v1/all/" + d[2] + "/" + d[0] + "/" + d[1] + ".mvt?api_key=gU55ZUmrR4iYlPtqon4g_Q";
        //        layers = ["roads", "aeroway", "water"];

        //var url = "https://api.maptiler.com/tiles/v3/" + d[2] + "/" + d[0] + "/" + d[1] + ".pbf?key=THIUxOiVkaLgsNtCXqMe";
        //var layers = ["transportation", "aeroway"];

        //url = "https://d2rfypejqz1iux.cloudfront.net/tilezen/vector/v1/256/all/" + d[2] + "/" + d[0] + "/" + d[1] + ".mvt?api_key=gU55ZUmrR4iYlPtqon4g_Q";

        var url = "https://3kje40nc62.execute-api.us-east-1.amazonaws.com/prod/tilezen/vector/v1/256/all/" + d[2] + "/" + d[0] + "/" + d[1] + ".mvt";

        var layers = ["roads", "aeroway", "water"];

    } else {
        var layers = ['water', 'roads'];
        var url = "https://d1w2ve2kvbvjmf.cloudfront.net/v1/" + d[2] + "/" + d[0] + "/" + d[1] + ".mvt";
    }

    this._xhr = d3.xhr(url).responseType('arraybuffer').get(function (error, json) {

        if (!error && json.status == 200) {

            try {
                var tile_res = new NewVectorTile(new Pbf(new Uint8Array(json.response)));
            } catch (e) {
                //console.log(e);
                return;
            }

            var features = [];
            layers.forEach(function (layer) {
                try {
                    for (var i = 0, len = tile_res.layers[layer].length; i < len; i++) {
                        var f = tile_res.layers[layer].feature(i).toGeoJSON(d[0], d[1], d[2]);
                        f.layer = layer;
                        if (f.geometry.type == "Point" || f.geometry.type == "MultiPoint") continue;
                        if (layer == "road" || layer == "roads" || layer == "transportation") {
                            if (f.properties.kind == "ferry") continue;
                            if (f.properties.kind == "rail") continue;
                            if (f.properties.class == "ferry") continue;
                            if (f.properties.class == "major_rail") continue;
                            if (f.properties.class == "minor_rail") continue;
                            if (f.properties.class == "pedestrian") continue;
                        }
                        if (layer == "water" && !f.properties.boundary) continue;
                        if (layer == "water" && f.properties.kind == "river") continue;
                        if (layer == "aeroway" && f.properties.class == "aerodrome") continue;
                        features.push(f);
                    }
                } catch (err) {
                    //console.log(err);
                }
            });

            var k = Math.pow(2, d[2]) * 256;

            // put all the features into SVG paths
            svg.selectAll("path")
                .data(features)
                .enter().append("path")
                .attr("class", function (d) {
                    return d.layer + "-layer " + (d.properties.class || d.properties.kind);
                })
                .attr("d", d3.geo.path()
                    .projection(d3.geo.mercator()
                        .scale(k / tau)
                        .translate([k / 2 - d[0] * 256, k / 2 - d[1] * 256])
                        .precision(0)));

        }


    });


};

function renderTopoTiles(d) {
    var svg = d3.select(this);
    this._xhr = d3.xhr("https://api.maptiler.com/tiles/contours/" + d[2] + "/" + d[0] + "/" + d[1] + ".pbf?key=THIUxOiVkaLgsNtCXqMe").responseType('arraybuffer').get(function (error, json) {

        if (!error && json.status == 200) {

            try {
                var tile_res = new NewVectorTile(new Pbf(new Uint8Array(json.response)));
            } catch (e) {
                return;
            }

            var features = [];
            for (var i = 0, len = tile_res.layers['contour'].length; i < len; i++) {
                features.push(tile_res.layers['contour'].feature(i).toGeoJSON(d[0], d[1], d[2]));
            }

            var k = Math.pow(2, d[2]) * 256;

            // put all the features into SVG paths
            svg.selectAll("path.contour-layer")
                .data(features)
                .enter().append("path")
                .attr("class", "contour-layer")
                .attr("d", d3.geo.path()
                    .projection(d3.geo.mercator()
                        .scale(k / tau)
                        .translate([k / 2 - d[0] * 256, k / 2 - d[1] * 256])
                        .precision(0)));
        }

        try {
            renderTopoWaterTiles(svg, d);
        } catch (water_error) {
            //
        }

    });

};

function renderTopoWaterTiles(svg, d) {

    var k = Math.pow(2, d[2]) * 256; // size of the world in pixels

    if (d[2] >= 13) {
        var url = "https://3kje40nc62.execute-api.us-east-1.amazonaws.com/prod/tilezen/vector/v1/256/all/" + d[2] + "/" + d[0] + "/" + d[1] + ".mvt";
        var layers = ["water"];

    } else {
        var layers = ['water'];
        var url = "https://d1w2ve2kvbvjmf.cloudfront.net/v1/" + d[2] + "/" + d[0] + "/" + d[1] + ".mvt";
    }

    this._xhr = d3.xhr(url).responseType('arraybuffer').get(function (error, json) {

        if (!error && json.status == 200) {

            try {
                var tile_res = new NewVectorTile(new Pbf(new Uint8Array(json.response)));
            } catch (e) {
                console.log(e);
                return;
            }

            var features = [];
            layers.forEach(function (layer) {
                try {
                    for (var i = 0, len = tile_res.layers[layer].length; i < len; i++) {
                        var f = tile_res.layers[layer].feature(i).toGeoJSON(d[0], d[1], d[2]);
                        f.layer = layer;
                        if (f.geometry.type == "Point" || f.geometry.type == "MultiPoint") continue;
                        if (layer == "road" || layer == "roads" || layer == "transportation") {
                            if (f.properties.kind == "ferry") continue;
                            if (f.properties.kind == "rail") continue;
                            if (f.properties.class == "ferry") continue;
                            if (f.properties.class == "major_rail") continue;
                            if (f.properties.class == "minor_rail") continue;
                            if (f.properties.class == "pedestrian") continue;
                        }
                        if (layer == "aeroway" && f.properties.class == "aerodrome") continue;
                        if (layer == "water" && !f.properties.boundary) continue;
                        if (layer == "water" && f.properties.kind == "river") continue;
                        features.push(f);
                    }
                } catch (err) {
                    //console.log(err);
                }
            });
            //console.log(features);

            svg.selectAll("path.water-layer")
                .data(features)
                .enter().append("path")
                .attr("class", "water-layer")
                .attr("d", d3.geo.path()
                    .projection(d3.geo.mercator()
                        .scale(k / tau)
                        .translate([k / 2 - d[0] * 256, k / 2 - d[1] * 256])
                        .precision(0)));
        }


    });

}

function resizeContainers() {
    var sf = $(".product-gallery--media").first().height() / 2000;
    $("#map-frame").css({
        transform: "scale(" + sf + ")",
    });
    $(".zoom-btns").css({
        transform: "translateY(-50%) scale(" + 1 / sf + ")",
    });
}

function switchStyle() {
    //setGlobals();
    if (map_style == "topographic") {
        zoomExtent = [1 << 10, 1 << 22];
        if (zoom.scale() < zoomExtent[0]) moveMap(lng, lat, zoomExtent[0]);
        else if (zoom.scale() > zoomExtent[1]) moveMap(lng, lat, zoomExtent[1]);
    }
    else {
        zoomExtent = [1 << 10, 1 << 24];
    }
    zoom.scaleExtent(zoomExtent);
    $("#map .layer .tile").remove();
    zoomed();
    if ($(window).width() < 736) {
        $(".product-gallery--media-thumbnail").eq(0).click();
        $(".product-gallery").first()[0].scrollIntoView(false);
    }
}

function matrix3d(scale, translate) {
    var k = scale / 256, r = scale % 1 ? Number : Math.round;
    return "matrix3d(" + [k, 0, 0, 0, 0, k, 0, 0, 0, 0, k, 0, r(translate[0] * scale), r(translate[1] * scale), 0, 1] + ")";
}

function prefixMatch(p) {
    var i = -1, n = p.length, s = document.body.style;
    while (++i < n) if (p[i] + "Transform" in s) return "-" + p[i].toLowerCase() + "-";
    return "";
}

function interpolateZoom(translate, scale) {
    return d3.transition().duration(350).tween("zoom", function () {
        var iTranslate = d3.interpolate(zoom.translate(), translate), iScale = d3.interpolate(zoom.scale(), scale);
        return function (t) {
            zoom.scale(iScale(t)).translate(iTranslate(t));
            zoomed();
        };
    });
}

function drawMapText() {
    $("input:checked").each(function (i) {
        var v = $(this).val().toLowerCase().replace(/ /g, '');
        if (v == "citystate") {
            document.getElementById('map-inscription-text').innerHTML = pJSON.city + ", " + pJSON.state;
            return;
        } else if (v == "coordinates") {
            document.getElementById('map-inscription-text').innerHTML = pJSON.coordinates.replace(/°/g, '');
            return;
        } else if (v == "blank") {
            document.getElementById('map-inscription-text').innerHTML = '';
            return;
        } else if (v == "custom") {
            document.getElementById('map-inscription-text').innerHTML = document.getElementById('custom_inscription_text').value;
            return;
        }
    });
}

function fitTextOnCanvas(ctx, text, width, max) {
    // start with a large font size
    var fontsize = max + 1;

    // lower the font size until the text fits the canvas
    do {
        fontsize--;
        ctx.font = "100 normal " + fontsize + "px " + " Copperplate";

    } while (ctx.measureText(text).width > width)

    return fontsize;
}

function updateMap() {

    try {
        var place = autocomplete.getPlace();
        lat = place.geometry.location.lat();
        lng = place.geometry.location.lng();
    } catch (e) {
        console.log("Google Map Search Location Error");
        return;
    }

    moveMap(lng, lat);

    pJSON.city = place.address_components[0].long_name;
    for (var i = 0; i < place.address_components.length; i += 1) {
        var addressObj = place.address_components[i];
        if (addressObj.types[0] === 'administrative_area_level_1') {
            pJSON.state = addressObj.long_name;
            break;
        }
        else if (addressObj.types[0] === 'country') {
            pJSON.state = addressObj.long_name;
        }
    };
    pJSON.coordinates = formatCoordinates(lng, lat, 2);
    setHiddenFields();
    drawMapText();
    $(".product-gallery--media-thumbnail").eq(1).click();
    if ($(window).width() < 736)
        $(".product-gallery").first()[1].scrollIntoView(false);
}

function moveMap(lng, lat, new_scale) {
    var tau = 2 * Math.PI;
    if (new_scale) {
        var t_projection = d3.geo.mercator()
            .scale(new_scale / tau) // change scale here, 21 is about z13
            .translate([-DIMS[bottle].map.map_area_width / 2, -DIMS[bottle].map.height / 2]); // just temporary
        var t_zoom = d3.behavior.zoom()
            //.scale(projection.scale() * 2 * Math.PI)
            .scale(new_scale)
            .scaleExtent(zoomExtent)
            .translate(t_projection([lng, lat]).map(function (x) { return -x; }));
        interpolateZoom(t_zoom.translate(), t_zoom.scale());
    } else {
        var t_projection = d3.geo.mercator().scale(zoom.scale() / tau).translate([-DIMS[bottle].map.map_area_width / 2, -DIMS[bottle].map.height / 2]);
        var t_zoom = d3.behavior.zoom().scale(projection.scale() * 2 * Math.PI).scaleExtent(zoomExtent).translate(t_projection([lng, lat]).map(function (x) {
            return -x;
        }));
        interpolateZoom(t_zoom.translate(), t_zoom.scale());
    }
}

function interpolateZoom(translate, scale) {
    return d3.transition().duration(350).tween("zoom", function () {
        var iTranslate = d3.interpolate(zoom.translate(), translate),
            iScale = d3.interpolate(zoom.scale(), scale);
        return function (t) {
            zoom.scale(iScale(t)).translate(iTranslate(t));
            zoomed();
        };
    });
}
function setHiddenFields() {
    lng = projection.invert([DIMS[bottle].map.map_area_width / 2, DIMS[bottle].map.height / 2])[0];
    lat = projection.invert([DIMS[bottle].map.map_area_width / 2, DIMS[bottle].map.height / 2])[1];
    pJSON.coordinates = formatCoordinates(lng, lat, 2);
    $("#print-size").attr("value", $("#jace-tshirt-size-label").text());
    $("#print-lng").attr("value", lng);
    $("#print-lat").attr("value", lat);
    $("#print-scale").attr("value", zoom.scale());
    //$("#print-text2, #print-line2").attr("data-value", ($("#line2-text").val() || formatCoordinates(lng, lat, 2))).attr("value", ($("#line2-text").val() || formatCoordinates(lng, lat, 2)));
    //$("#print-text1, #print-line1").attr("data-value", ($("#line1-text").val() || pJSON.city)).attr("value", ($("#line1-text").val() || pJSON.city));
    $("#print-location").attr("value", formatCoordinates(lng, lat, 2));
    var print_url = "&lng=" + lng + "&lat=" + lat + "&scale=" + zoom.scale() + "&size=" + $("#jace-tshirt-size-label").text();
    if ($(".options-selection__option-value-input[Value='Custom']:checked").length) {
        print_url += "&custom-text=" + $("#custom_inscription_text").val();
        $("#print-custom-text").attr("value", $("#custom_inscription_text").val());
    } else $("#print-custom-text").removeAttr("value");
    $("#print-url").attr("data-value", print_url).attr("value", print_url);
    $("a.share-buttons--email").attr("href", "mailto:?body=" + window.location.href.split('?')[0] + "?" + encodeURIComponent(print_url));

}

function formatCoordinates(lng, lat, decimals) {
    var longitude = Number(lng),
        latitude = Number(lat),
        dlng = (longitude < 0) ? "W" : "E",
        dlat = (latitude < 0) ? "S" : "N";

    if (decimals) return Math.abs(latitude).toFixed(decimals) + "°" + dlat + " " + Math.abs(longitude).toFixed(decimals) + "°" + dlng;
    else return Math.abs(latitude).toFixed(2) + "°" + dlat + " " + Math.abs(longitude).toFixed(2) + "°" + dlng;
}

function initAutocomplete() {
    autocomplete = new google.maps.places.Autocomplete(document.getElementById("autocomplete"), {
        types: ["geocode", "establishment"]
    });
    autocomplete.addListener("place_changed", updateMap);
}

function setGlobals() {
    var JACE_P = JSON.parse($("script[data-section-type='static-product']").html());
    for (var i = 0; i < JACE_P.product.tags.length; i++) {
        if (JACE_P.product.tags[i].indexOf("Apparel_") == 0)
            apparel_style = JACE_P.product.tags[i].split("Apparel_")[1];
    }
    $("input:checked").each(function (i) {
        var v = $(this).val().toLowerCase().replace(/ /g, '');
        if (v == 'xs' || v == 's' || v == 'm' || v == 'l' || v == 'xl' || v == '2xl') {
            // no changes with size
        } else if (v == 'standard') {
            map_style = "standard";
        } else if (v == 'topographic') {
            map_style = "topographic";
        } else if (v == "citystate" || v == "coordinates" || v == "blank" || v == "custom") {
            if (v == "custom") $("#custom_inscription_text").show();
            drawMapText();
        } else {
            COLOR = v;
        }
    });
}

function registerForm() {
    $(".options-selection__option-value-input").change(function () {
        const v = $(this).val().toLowerCase().replace(/ /g, '');
        setHiddenFields();
        if (v == "xs" || v == "s" || v == "m" || v == "l" || v == "xl" || v == "2xl") {
            // Change size on custom properties
            $("#jace-tshirt-size-label").text($(this).val());
            $("#jace-tshirt-size").attr("data-value", $(this).val()).val($(this).val());
        } else if (v == 'standard') {
            map_style = "standard";
            switchStyle();
            updateImages();
        } else if (v == 'topographic') {
            map_style = "topographic";
            switchStyle();
            updateImages();
        } else if (v == "citystate" || v == "coordinates" || v == "blank" || v == "custom") {
            drawMapText();
            if (v == "custom") $("#custom_inscription_text").show().click().focus();
            else $("#custom_inscription_text").hide();
            updateImages();
        } else {
            COLOR = v;
            updateImages();
        }
    });
    $("#custom_inscription_text").on('input', function () {
        drawMapText();
        setHiddenFields();
    });
    $("#custom_inscription_text").on('focusout', function () {
        updateImages();
        setHiddenFields();
    });
    $("#map").bind("pointerdown touchstart", function (e) {
        if (e.originalEvent.pointerType == "touch") {
            e.preventDefault();
            e.stopPropagation();
        }
    });
    $(window).resize(function () {
        setTimeout(function () {
            resizeContainers();
            //registerMap();
        }, 500);
    });
    $(".zoom-btn").click(function () {
        var direction = Number($(this).attr("data-direction")),
            factor = 0.5,
            target_zoom = 1,
            center = [DIMS[bottle].map.map_area_width / 2, DIMS[bottle].map.height / 2],
            extent = zoom.scaleExtent(),
            translate = zoom.translate(),
            translate0 = [],
            l = [],
            view2 = { x: translate[0], y: translate[1], k: zoom.scale() };
        target_zoom = zoom.scale() * (1 + factor * direction);
        if (target_zoom < extent[0] || target_zoom > extent[1]) null
        else {
            translate0 = [(center[0] - view2.x) / view2.k, (center[1] - view2.y) / view2.k];
            view2.k = target_zoom;
            l = [translate0[0] * view2.k + view2.x, translate0[1] * view2.k + view2.y];

            view2.x += center[0] - l[0];
            view2.y += center[1] - l[1];

            interpolateZoom([view2.x, view2.y], view2.k);
        }
    });
    document.getElementById('autocomplete').addEventListener('click', function () {
        if (document.getElementById("autocomplete").value != "") document.getElementById("autocomplete").value = "";
    });
    $(".product-gallery--image-thumbnail").on('click', function () {
        if ($(this).attr("data-gallery-index") !== 1 && waitZoomed) {
            drawMapText();
            updateImages();
            waitZoomed = false;
        }
    });
}

function updateImages() {

    updateSquare();
    generateSVGMap(function () {
        updateFlat();
        updateLifestyle1();
        updateLifestyle2();
    });

}

function updateDetailsCanvas() {


    var canvas = document.getElementById('jace_tshirts_details_canvas'),
        ctx = canvas.getContext("2d"),
        width = 1600,
        height = 1067;

    if (apparel_style == "Tshirt") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/tshirt_' + COLOR + "_twomodels.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(.47, Math.tan(-1 * Math.PI / 60), 0, .47, 370, 120);
            ctx.drawImage(source_image, 492, 1018, 310, 324); // Woman
            ctx.resetTransform();
            ctx.setTransform(.45, -0.06, 0.06, .46, 425, 80); // Man
            ctx.drawImage(source_image, 1100, 920, 305, 319);
            ctx.resetTransform();
        };
    } else if (apparel_style == "Longsleeve") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/longsleeve_' + COLOR + "_fall.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0, 0, 1, 718, 430);
            ctx.drawImage(source_image, 0, 0, 200, 223);
            ctx.resetTransform();
        };
    } else if (apparel_style == "Crewneck") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/crewneck_' + COLOR + "_wall.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0, 0, 1, 577, 480);
            ctx.drawImage(source_image, 0, 0, 210, 213);
            ctx.resetTransform();
        };
    } else if (apparel_style == "Hoodie") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/hoodie_' + COLOR + "_gate.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0, -0, 1, 750, 450);
            ctx.drawImage(source_image, 0, 0, 160, 167);
            ctx.resetTransform();

            const overlay = new Image;
            overlay.setAttribute('crossorigin', 'anonymous');
            overlay.src = "https://cdn.shopify.com/s/files/1/0310/8211/9308/files/hoodie_" + COLOR + "_gate.png";
            overlay.onload = function () {
                ctx.drawImage(overlay, 0, 0, width, height);
                thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
            }

        };
    }
}

function updateLifestyle1() {

    var canvas = document.getElementById('jace_tshirts_man_canvas'),
        ctx = canvas.getContext("2d"),
        width = 2000,
        height = 2000,
        thumb_canvas = document.getElementById('jace_tshirts_man_thumb_canvas'),
        thumb_ctx = thumb_canvas.getContext("2d"),
        thumb_width = 150,
        thumb_height = 150;

    if (apparel_style == "Tshirt") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/tshirt_' + COLOR + "_man.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.drawImage(source_image, 833, 848, 366, 373);
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
        };
    } else if (apparel_style == "Longsleeve") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/longsleeve_' + COLOR + "_shop.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, .01, -0.03, 1, 840, 842);
            ctx.drawImage(source_image, 0, 0, 350, 366);
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
            ctx.resetTransform();
        };
    } else if (apparel_style == "Crewneck") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/crewneck_' + COLOR + "_chain.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, -0, 0, 1, 800, 840);
            ctx.drawImage(source_image, 0, 0, 340, 355);
            ctx.resetTransform();

            const overlay = new Image;
            overlay.setAttribute('crossorigin', 'anonymous');
            overlay.src = "https://cdn.shopify.com/s/files/1/0310/8211/9308/files/crewneck_chain.png?v=1741908495";
            overlay.onload = function () {
                ctx.drawImage(overlay, 0, 0, width, height);
                thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
            }

        };
    } else if (apparel_style == "Hoodie") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/hoodie_' + COLOR + "_board.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0, -0, 1, 890, 480);
            ctx.drawImage(source_image, 0, 0, 170, 177);
            ctx.resetTransform();

            const overlay = new Image;
            overlay.setAttribute('crossorigin', 'anonymous');
            overlay.src = "https://cdn.shopify.com/s/files/1/0310/8211/9308/files/hoodie_" + COLOR + "_board.png";
            overlay.onload = function () {
                ctx.drawImage(overlay, 0, 0, width, height);
                thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
            }

        };
    }

}

function updateLifestyle2() {

    var canvas = document.getElementById('jace_tshirts_woman_canvas'),
        ctx = canvas.getContext("2d"),
        width = 2000,
        height = 2000,
        thumb_canvas = document.getElementById('jace_tshirts_woman_thumb_canvas'),
        thumb_ctx = thumb_canvas.getContext("2d"),
        thumb_width = 150,
        thumb_height = 150;

    if (apparel_style == "Tshirt") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/tshirt_' + COLOR + "_woman.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, Math.tan(Math.PI / 60), 0, 1, 0, 0);
            ctx.drawImage(source_image, 880, 838, 324, 338);
            ctx.resetTransform();
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
        };
    } else if (apparel_style == "Longsleeve") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/longsleeve_' + COLOR + "_vest.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0.17, -0.17, 1, 987, 880);
            ctx.drawImage(source_image, 0, 0, 500, 523);
            ctx.resetTransform();
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
        };
    } else if (apparel_style == "Crewneck") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/crewneck_' + COLOR + "_smile.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0.14, -0.14, 1, 790, 840);
            ctx.drawImage(source_image, 0, 0, 340, 355);
            ctx.resetTransform();
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
        };
    } else if (apparel_style == "Hoodie") {
        const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/hoodie_' + COLOR + "_jeans.jpg";
        var bg_img = new Image;
        bg_img.setAttribute('crossorigin', 'anonymous');
        bg_img.src = T_URL;
        bg_img.onload = function () {
            ctx.drawImage(bg_img, 0, 0, width, height);
            ctx.setTransform(1, 0, -0, 1, 860, 750);
            ctx.drawImage(source_image, 0, 0, 295, 308);
            ctx.resetTransform();
            thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
        };
    }
}

function updateFlat() {
    const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/' + apparel_style.toLowerCase() + '_' + COLOR + "_flat.jpg";

    var canvas = document.getElementById('jace_tshirts_flat_canvas'),
        ctx = canvas.getContext("2d"),
        width = 2000,
        height = 2000,
        thumb_canvas = document.getElementById('jace_tshirts_flat_thumb_canvas'),
        thumb_ctx = thumb_canvas.getContext("2d"),
        thumb_width = 150,
        thumb_height = 150;

    var bg_img = new Image;
    bg_img.setAttribute('crossorigin', 'anonymous');
    bg_img.src = T_URL;
    bg_img.onload = function () {
        ctx.drawImage(bg_img, 0, 0, width, height);
        ctx.drawImage(source_image, 752, 572, 494, 517);
        thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
    };
}

function updateGhost() {
    const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/tshirt_' + COLOR + "_ghost.jpg";

    var canvas = document.getElementById('jace_tshirts_ghost_canvas'),
        ctx = canvas.getContext("2d"),
        width = 2000,
        height = 2000,
        thumb_canvas = document.getElementById('jace_tshirts_ghost_thumb_canvas'),
        thumb_ctx = thumb_canvas.getContext("2d"),
        thumb_width = 150,
        thumb_height = 150;

    var bg_img = new Image;
    bg_img.setAttribute('crossorigin', 'anonymous');
    bg_img.src = T_URL;
    bg_img.onload = function () {
        ctx.drawImage(bg_img, 0, 0, width, height);
        ctx.drawImage(source_image, 1113, 947, 350, 366);
        thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
    };
}

function updateSquare() {
    const T_URL = '//cdn.shopify.com/s/files/1/0310/8211/9308/files/' + apparel_style.toLowerCase() + '_' + COLOR + "_square.jpg";

    var canvas = document.getElementById('jace_tshirts_square_canvas'),
        ctx = canvas.getContext("2d"),
        width = 2000,
        height = 2000,
        thumb_canvas = document.getElementById('jace_tshirts_square_thumb_canvas'),
        thumb_ctx = thumb_canvas.getContext("2d"),
        thumb_width = 150,
        thumb_height = 150;

    var bg_img = new Image;
    bg_img.setAttribute('crossorigin', 'anonymous');
    bg_img.src = T_URL;
    bg_img.onload = function () {
        ctx.drawImage(bg_img, 0, 0, width, height);
        //ctx.drawImage(source_image, (width - source_image.width * 2) / 2, (height - source_image.height * 2) / 2, source_image.width * 2, source_image.height * 2);
        thumb_ctx.drawImage(canvas, 0, 0, thumb_width, thumb_height);
    };
}
